const initialState = {
  isFetching: false,
  isFetched: false,
  marketplace_categories: [],
};

const reducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case 'MARKETPLACE/CATEGORIES_REQUEST':
      return { ...state, isFetching: true, isFetched: false };
    case 'MARKETPLACE/CATEGORIES_FAILURE':
      return { ...state, isFetching: false, isFetched: false };
    case 'MARKETPLACE/CATEGORIES_SUCCESS':
      return { ...state, isFetching: false, isFetched: true, marketplace_categories: payload.marketplace_categories };

    case 'MARKETPLACE/RESET':
      return initialState;
    default:
      return state;
  };
};

export default reducer;